import { createEventEmitter } from '../core/eventEmitter';
export const createEntityStateEmitter = () => {
  const stateEmitters = new Map();
  const getStateEmitter = entity => {
    if (!stateEmitters.has(entity.typeIdentifier)) {
      stateEmitters.set(entity.typeIdentifier, createEventEmitter());
    }
    return stateEmitters.get(entity.typeIdentifier);
  };
  return {
    count: (entity, instanceKey) => getStateEmitter(entity).count(instanceKey),
    emit: (entity, instanceKey, state) => {
      getStateEmitter(entity).emit(instanceKey, state);
    },
    subscribe: (entity, instanceKey, callback) => {
      const unsubscribe = getStateEmitter(entity).subscribe(instanceKey, callback);
      return () => {
        const remaining = unsubscribe();
        if (!getStateEmitter(entity).hasAnyListeners()) {
          stateEmitters.delete(entity.typeIdentifier);
        }
        return remaining;
      };
    }
  };
};